import _asyncToGenerator from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import _regeneratorRuntime from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/regenerator/index.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a, _b;
import { Color, DoubleSide, FrontSide, Vector2 } from 'three';
import { PBRMetallicRoughness } from './pbr-metallic-roughness.js';
import { TextureInfo, TextureUsage } from './texture-info.js';
import { $correlatedObjects, $onUpdate, ThreeDOMElement } from './three-dom-element.js';
var $pbrMetallicRoughness = Symbol('pbrMetallicRoughness');
var $normalTexture = Symbol('normalTexture');
var $occlusionTexture = Symbol('occlusionTexture');
var $emissiveTexture = Symbol('emissiveTexture');
var $backingThreeMaterial = Symbol('backingThreeMaterial');
var $applyAlphaCutoff = Symbol('applyAlphaCutoff');
var $getAlphaMode = Symbol('getAlphaMode');
export var $lazyLoadGLTFInfo = Symbol('lazyLoadGLTFInfo');
var $initialize = Symbol('initialize');
export var $getLoadedMaterial = Symbol('getLoadedMaterial');
export var $ensureMaterialIsLoaded = Symbol('ensureMaterialIsLoaded');
export var $gltfIndex = Symbol('gltfIndex');
export var $setActive = Symbol('setActive');
export var $variantIndices = Symbol('variantIndices');
var $isActive = Symbol('isActive');
export var $variantSet = Symbol('variantSet');
var $modelVariants = Symbol('modelVariants');
var $name = Symbol('name');
var $pbrTextures = Symbol('pbrTextures');
/**
 * Material facade implementation for Three.js materials
 */
export var Material = /*#__PURE__*/function (_ThreeDOMElement, _ref) {
  _inherits(Material, _ThreeDOMElement);
  var _super = _createSuper(Material);
  function Material(onUpdate, gltfIndex, isActive, modelVariants, correlatedMaterials, name) {
    var _this;
    var lazyLoadInfo = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : undefined;
    _classCallCheck(this, Material);
    _this = _super.call(this, onUpdate, correlatedMaterials);
    _this[_a] = new Set();
    _this[_b] = new Map();
    _this[$gltfIndex] = gltfIndex;
    _this[$isActive] = isActive;
    _this[$modelVariants] = modelVariants;
    _this[$name] = name;
    if (lazyLoadInfo == null) {
      _this[$initialize]();
    } else {
      _this[$lazyLoadGLTFInfo] = lazyLoadInfo;
    }
    return _this;
  }
  _createClass(Material, [{
    key: _ref,
    get: function get() {
      return this[$correlatedObjects].values().next().value;
    }
  }, {
    key: $initialize,
    value: function value() {
      var _this2 = this;
      var onUpdate = this[$onUpdate];
      var correlatedMaterials = this[$correlatedObjects];
      this[$pbrMetallicRoughness] = new PBRMetallicRoughness(onUpdate, correlatedMaterials);
      var _correlatedMaterials$ = correlatedMaterials.values().next().value,
        normalMap = _correlatedMaterials$.normalMap,
        aoMap = _correlatedMaterials$.aoMap,
        emissiveMap = _correlatedMaterials$.emissiveMap;
      this[$normalTexture] = new TextureInfo(onUpdate, TextureUsage.Normal, normalMap, correlatedMaterials);
      this[$occlusionTexture] = new TextureInfo(onUpdate, TextureUsage.Occlusion, aoMap, correlatedMaterials);
      this[$emissiveTexture] = new TextureInfo(onUpdate, TextureUsage.Emissive, emissiveMap, correlatedMaterials);
      var createTextureInfo = function createTextureInfo(usage) {
        _this2[$pbrTextures].set(usage, new TextureInfo(onUpdate, usage, null, correlatedMaterials));
      };
      createTextureInfo(TextureUsage.Clearcoat);
      createTextureInfo(TextureUsage.ClearcoatRoughness);
      createTextureInfo(TextureUsage.ClearcoatNormal);
      createTextureInfo(TextureUsage.SheenColor);
      createTextureInfo(TextureUsage.SheenRoughness);
      createTextureInfo(TextureUsage.Transmission);
      createTextureInfo(TextureUsage.Thickness);
      createTextureInfo(TextureUsage.Specular);
      createTextureInfo(TextureUsage.SpecularColor);
      createTextureInfo(TextureUsage.Iridescence);
      createTextureInfo(TextureUsage.IridescenceThickness);
      createTextureInfo(TextureUsage.Anisotropy);
    }
  }, {
    key: $getLoadedMaterial,
    value: function () {
      var _value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _yield$this$$lazyLoad, set, material;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this[$lazyLoadGLTFInfo] != null)) {
                _context2.next = 11;
                break;
              }
              _context2.next = 3;
              return this[$lazyLoadGLTFInfo].doLazyLoad();
            case 3:
              _yield$this$$lazyLoad = _context2.sent;
              set = _yield$this$$lazyLoad.set;
              material = _yield$this$$lazyLoad.material;
              // Fills in the missing data.
              this[$correlatedObjects] = set;
              this[$initialize]();
              // Releases lazy load info.
              this[$lazyLoadGLTFInfo] = undefined;
              // Redefines the method as a noop method.
              this.ensureLoaded = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return _context2.abrupt("return", material);
            case 11:
              return _context2.abrupt("return", this[$correlatedObjects].values().next().value);
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function value() {
        return _value.apply(this, arguments);
      }
      return value;
    }()
  }, {
    key: "colorFromRgb",
    value: function colorFromRgb(rgb) {
      var color = new Color();
      if (rgb instanceof Array) {
        color.fromArray(rgb);
      } else {
        color.set(rgb);
      }
      return color;
    }
  }, {
    key: $ensureMaterialIsLoaded,
    value: function value() {
      if (this[$lazyLoadGLTFInfo] == null) {
        return;
      }
      throw new Error("Material \"".concat(this.name, "\" has not been loaded, call 'await\n    myMaterial.ensureLoaded()' before using an unloaded material."));
    }
  }, {
    key: "ensureLoaded",
    value: function () {
      var _ensureLoaded = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this[$getLoadedMaterial]();
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function ensureLoaded() {
        return _ensureLoaded.apply(this, arguments);
      }
      return ensureLoaded;
    }()
  }, {
    key: "isLoaded",
    get: function get() {
      return this[$lazyLoadGLTFInfo] == null;
    }
  }, {
    key: "isActive",
    get: function get() {
      return this[$isActive];
    }
  }, {
    key: $setActive,
    value: function value(isActive) {
      this[$isActive] = isActive;
    }
  }, {
    key: "name",
    get: function get() {
      return this[$name] || '';
    }
  }, {
    key: "name",
    set: function set(name) {
      this[$name] = name;
      if (this[$correlatedObjects] != null) {
        var _iterator = _createForOfIteratorHelper(this[$correlatedObjects]),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var threeMaterial = _step.value;
            threeMaterial.name = name;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }, {
    key: "pbrMetallicRoughness",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$pbrMetallicRoughness];
    }
  }, {
    key: "normalTexture",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$normalTexture];
    }
  }, {
    key: "occlusionTexture",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$occlusionTexture];
    }
  }, {
    key: "emissiveTexture",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$emissiveTexture];
    }
  }, {
    key: "emissiveFactor",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$backingThreeMaterial].emissive.toArray();
    }
  }, {
    key: "index",
    get: function get() {
      return this[$gltfIndex];
    }
  }, {
    key: $variantIndices,
    value: function value() {
      return this[$variantSet];
    }
  }, {
    key: "hasVariant",
    value: function hasVariant(name) {
      var variantData = this[$modelVariants].get(name);
      return variantData != null && this[$variantSet].has(variantData.index);
    }
  }, {
    key: "setEmissiveFactor",
    value: function setEmissiveFactor(rgb) {
      this[$ensureMaterialIsLoaded]();
      var color = this.colorFromRgb(rgb);
      var _iterator2 = _createForOfIteratorHelper(this[$correlatedObjects]),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var material = _step2.value;
          material.emissive.set(color);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this[$onUpdate]();
    }
  }, {
    key: $getAlphaMode,
    value: function value() {
      // Follows implementation of GLTFExporter from three.js
      if (this[$backingThreeMaterial].transparent) {
        return 'BLEND';
      } else {
        if (this[$backingThreeMaterial].alphaTest > 0.0) {
          return 'MASK';
        }
      }
      return 'OPAQUE';
    }
  }, {
    key: $applyAlphaCutoff,
    value: function value() {
      this[$ensureMaterialIsLoaded]();
      var _iterator3 = _createForOfIteratorHelper(this[$correlatedObjects]),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var material = _step3.value;
          if (this[$getAlphaMode]() === 'MASK') {
            if (material.alphaTest == undefined) {
              material.alphaTest = 0.5;
            }
          } else {
            material.alphaTest = undefined;
          }
          material.needsUpdate = true;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "setAlphaCutoff",
    value: function setAlphaCutoff(cutoff) {
      this[$ensureMaterialIsLoaded]();
      var _iterator4 = _createForOfIteratorHelper(this[$correlatedObjects]),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var material = _step4.value;
          material.alphaTest = cutoff;
          material.needsUpdate = true;
        }
        // Set AlphaCutoff to undefined if AlphaMode is not MASK.
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      this[$applyAlphaCutoff]();
      this[$onUpdate]();
    }
  }, {
    key: "getAlphaCutoff",
    value: function getAlphaCutoff() {
      this[$ensureMaterialIsLoaded]();
      return this[$backingThreeMaterial].alphaTest;
    }
  }, {
    key: "setDoubleSided",
    value: function setDoubleSided(doubleSided) {
      this[$ensureMaterialIsLoaded]();
      var _iterator5 = _createForOfIteratorHelper(this[$correlatedObjects]),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var material = _step5.value;
          // When double-sided is disabled gltf spec dictates that Back-Face culling
          // must be disabled, in three.js parlance that would mean FrontSide
          // rendering only.
          // https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#double-sided
          material.side = doubleSided ? DoubleSide : FrontSide;
          material.needsUpdate = true;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      this[$onUpdate]();
    }
  }, {
    key: "getDoubleSided",
    value: function getDoubleSided() {
      this[$ensureMaterialIsLoaded]();
      return this[$backingThreeMaterial].side == DoubleSide;
    }
  }, {
    key: "setAlphaMode",
    value: function setAlphaMode(alphaMode) {
      this[$ensureMaterialIsLoaded]();
      var enableTransparency = function enableTransparency(material, enabled) {
        material.transparent = enabled;
        material.depthWrite = !enabled;
      };
      var _iterator6 = _createForOfIteratorHelper(this[$correlatedObjects]),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var material = _step6.value;
          enableTransparency(material, alphaMode === 'BLEND');
          if (alphaMode === 'MASK') {
            material.alphaTest = 0.5;
          } else {
            material.alphaTest = undefined;
          }
          material.needsUpdate = true;
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      this[$onUpdate]();
    }
  }, {
    key: "getAlphaMode",
    value: function getAlphaMode() {
      this[$ensureMaterialIsLoaded]();
      return this[$getAlphaMode]();
    }
    /**
     * PBR Next properties.
     */
    // KHR_materials_emissive_strength
  }, {
    key: "emissiveStrength",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$backingThreeMaterial].emissiveIntensity;
    }
  }, {
    key: "setEmissiveStrength",
    value: function setEmissiveStrength(emissiveStrength) {
      this[$ensureMaterialIsLoaded]();
      var _iterator7 = _createForOfIteratorHelper(this[$correlatedObjects]),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var material = _step7.value;
          material.emissiveIntensity = emissiveStrength;
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      this[$onUpdate]();
    }
    // KHR_materials_clearcoat
  }, {
    key: "clearcoatFactor",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$backingThreeMaterial].clearcoat;
    }
  }, {
    key: "clearcoatRoughnessFactor",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$backingThreeMaterial].clearcoatRoughness;
    }
  }, {
    key: "clearcoatTexture",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$pbrTextures].get(TextureUsage.Clearcoat);
    }
  }, {
    key: "clearcoatRoughnessTexture",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$pbrTextures].get(TextureUsage.ClearcoatRoughness);
    }
  }, {
    key: "clearcoatNormalTexture",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$pbrTextures].get(TextureUsage.ClearcoatNormal);
    }
  }, {
    key: "clearcoatNormalScale",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$backingThreeMaterial].clearcoatNormalScale.x;
    }
  }, {
    key: "setClearcoatFactor",
    value: function setClearcoatFactor(clearcoatFactor) {
      this[$ensureMaterialIsLoaded]();
      var _iterator8 = _createForOfIteratorHelper(this[$correlatedObjects]),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var material = _step8.value;
          material.clearcoat = clearcoatFactor;
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      this[$onUpdate]();
    }
  }, {
    key: "setClearcoatRoughnessFactor",
    value: function setClearcoatRoughnessFactor(clearcoatRoughnessFactor) {
      this[$ensureMaterialIsLoaded]();
      var _iterator9 = _createForOfIteratorHelper(this[$correlatedObjects]),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var material = _step9.value;
          material.clearcoatRoughness = clearcoatRoughnessFactor;
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
      this[$onUpdate]();
    }
  }, {
    key: "setClearcoatNormalScale",
    value: function setClearcoatNormalScale(clearcoatNormalScale) {
      this[$ensureMaterialIsLoaded]();
      var _iterator10 = _createForOfIteratorHelper(this[$correlatedObjects]),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var material = _step10.value;
          material.clearcoatNormalScale = new Vector2(clearcoatNormalScale, clearcoatNormalScale);
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
      this[$onUpdate]();
    }
    // KHR_materials_ior
  }, {
    key: "ior",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$backingThreeMaterial].ior;
    }
  }, {
    key: "setIor",
    value: function setIor(ior) {
      this[$ensureMaterialIsLoaded]();
      var _iterator11 = _createForOfIteratorHelper(this[$correlatedObjects]),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var material = _step11.value;
          material.ior = ior;
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      this[$onUpdate]();
    }
    // KHR_materials_sheen
  }, {
    key: "sheenColorFactor",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$backingThreeMaterial].sheenColor.toArray();
    }
  }, {
    key: "sheenColorTexture",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$pbrTextures].get(TextureUsage.SheenColor);
    }
  }, {
    key: "sheenRoughnessFactor",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$backingThreeMaterial].sheenRoughness;
    }
  }, {
    key: "sheenRoughnessTexture",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$pbrTextures].get(TextureUsage.SheenRoughness);
    }
  }, {
    key: "setSheenColorFactor",
    value: function setSheenColorFactor(rgb) {
      this[$ensureMaterialIsLoaded]();
      var color = this.colorFromRgb(rgb);
      var _iterator12 = _createForOfIteratorHelper(this[$correlatedObjects]),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var material = _step12.value;
          material.sheenColor.set(color);
          // Three.js GLTFExporter checks for internal sheen value.
          material.sheen = 1;
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
      this[$onUpdate]();
    }
  }, {
    key: "setSheenRoughnessFactor",
    value: function setSheenRoughnessFactor(roughness) {
      this[$ensureMaterialIsLoaded]();
      var _iterator13 = _createForOfIteratorHelper(this[$correlatedObjects]),
        _step13;
      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var material = _step13.value;
          material.sheenRoughness = roughness;
          // Three.js GLTFExporter checks for internal sheen value.
          material.sheen = 1;
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
      this[$onUpdate]();
    }
    // KHR_materials_transmission
  }, {
    key: "transmissionFactor",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$backingThreeMaterial].transmission;
    }
  }, {
    key: "transmissionTexture",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$pbrTextures].get(TextureUsage.Transmission);
    }
  }, {
    key: "setTransmissionFactor",
    value: function setTransmissionFactor(transmission) {
      this[$ensureMaterialIsLoaded]();
      var _iterator14 = _createForOfIteratorHelper(this[$correlatedObjects]),
        _step14;
      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var material = _step14.value;
          material.transmission = transmission;
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
      this[$onUpdate]();
    }
    // KHR_materials_volume
  }, {
    key: "thicknessFactor",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$backingThreeMaterial].thickness;
    }
  }, {
    key: "thicknessTexture",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$pbrTextures].get(TextureUsage.Thickness);
    }
  }, {
    key: "attenuationDistance",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$backingThreeMaterial].attenuationDistance;
    }
  }, {
    key: "attenuationColor",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$backingThreeMaterial].attenuationColor.toArray();
    }
  }, {
    key: "setThicknessFactor",
    value: function setThicknessFactor(thickness) {
      this[$ensureMaterialIsLoaded]();
      var _iterator15 = _createForOfIteratorHelper(this[$correlatedObjects]),
        _step15;
      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var material = _step15.value;
          material.thickness = thickness;
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
      this[$onUpdate]();
    }
  }, {
    key: "setAttenuationDistance",
    value: function setAttenuationDistance(attenuationDistance) {
      this[$ensureMaterialIsLoaded]();
      var _iterator16 = _createForOfIteratorHelper(this[$correlatedObjects]),
        _step16;
      try {
        for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
          var material = _step16.value;
          material.attenuationDistance = attenuationDistance;
        }
      } catch (err) {
        _iterator16.e(err);
      } finally {
        _iterator16.f();
      }
      this[$onUpdate]();
    }
  }, {
    key: "setAttenuationColor",
    value: function setAttenuationColor(rgb) {
      this[$ensureMaterialIsLoaded]();
      var color = this.colorFromRgb(rgb);
      var _iterator17 = _createForOfIteratorHelper(this[$correlatedObjects]),
        _step17;
      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var material = _step17.value;
          material.attenuationColor.set(color);
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }
      this[$onUpdate]();
    }
    // KHR_materials_specular
  }, {
    key: "specularFactor",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$backingThreeMaterial].specularIntensity;
    }
  }, {
    key: "specularTexture",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$pbrTextures].get(TextureUsage.Specular);
    }
  }, {
    key: "specularColorFactor",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$backingThreeMaterial].specularColor.toArray();
    }
  }, {
    key: "specularColorTexture",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$pbrTextures].get(TextureUsage.SheenColor);
    }
  }, {
    key: "setSpecularFactor",
    value: function setSpecularFactor(specularFactor) {
      this[$ensureMaterialIsLoaded]();
      var _iterator18 = _createForOfIteratorHelper(this[$correlatedObjects]),
        _step18;
      try {
        for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
          var material = _step18.value;
          material.specularIntensity = specularFactor;
        }
      } catch (err) {
        _iterator18.e(err);
      } finally {
        _iterator18.f();
      }
      this[$onUpdate]();
    }
  }, {
    key: "setSpecularColorFactor",
    value: function setSpecularColorFactor(rgb) {
      this[$ensureMaterialIsLoaded]();
      var color = this.colorFromRgb(rgb);
      var _iterator19 = _createForOfIteratorHelper(this[$correlatedObjects]),
        _step19;
      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var material = _step19.value;
          material.specularColor.set(color);
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }
      this[$onUpdate]();
    }
    // KHR_materials_iridescence
  }, {
    key: "iridescenceFactor",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$backingThreeMaterial].iridescence;
    }
  }, {
    key: "iridescenceTexture",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$pbrTextures].get(TextureUsage.Iridescence);
    }
  }, {
    key: "iridescenceIor",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$backingThreeMaterial].iridescenceIOR;
    }
  }, {
    key: "iridescenceThicknessMinimum",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$backingThreeMaterial].iridescenceThicknessRange[0];
    }
  }, {
    key: "iridescenceThicknessMaximum",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$backingThreeMaterial].iridescenceThicknessRange[1];
    }
  }, {
    key: "iridescenceThicknessTexture",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$pbrTextures].get(TextureUsage.IridescenceThickness);
    }
  }, {
    key: "setIridescenceFactor",
    value: function setIridescenceFactor(iridescence) {
      this[$ensureMaterialIsLoaded]();
      var _iterator20 = _createForOfIteratorHelper(this[$correlatedObjects]),
        _step20;
      try {
        for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
          var material = _step20.value;
          material.iridescence = iridescence;
        }
      } catch (err) {
        _iterator20.e(err);
      } finally {
        _iterator20.f();
      }
      this[$onUpdate]();
    }
  }, {
    key: "setIridescenceIor",
    value: function setIridescenceIor(ior) {
      this[$ensureMaterialIsLoaded]();
      var _iterator21 = _createForOfIteratorHelper(this[$correlatedObjects]),
        _step21;
      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var material = _step21.value;
          material.iridescenceIOR = ior;
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }
      this[$onUpdate]();
    }
  }, {
    key: "setIridescenceThicknessMinimum",
    value: function setIridescenceThicknessMinimum(thicknessMin) {
      this[$ensureMaterialIsLoaded]();
      var _iterator22 = _createForOfIteratorHelper(this[$correlatedObjects]),
        _step22;
      try {
        for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
          var material = _step22.value;
          material.iridescenceThicknessRange[0] = thicknessMin;
        }
      } catch (err) {
        _iterator22.e(err);
      } finally {
        _iterator22.f();
      }
      this[$onUpdate]();
    }
  }, {
    key: "setIridescenceThicknessMaximum",
    value: function setIridescenceThicknessMaximum(thicknessMax) {
      this[$ensureMaterialIsLoaded]();
      var _iterator23 = _createForOfIteratorHelper(this[$correlatedObjects]),
        _step23;
      try {
        for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
          var material = _step23.value;
          material.iridescenceThicknessRange[1] = thicknessMax;
        }
      } catch (err) {
        _iterator23.e(err);
      } finally {
        _iterator23.f();
      }
      this[$onUpdate]();
    }
    // KHR_materials_anisotropy
  }, {
    key: "anisotropyStrength",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$backingThreeMaterial].anisotropy;
    }
  }, {
    key: "anisotropyRotation",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$backingThreeMaterial].anisotropyRotation;
    }
  }, {
    key: "anisotropyTexture",
    get: function get() {
      this[$ensureMaterialIsLoaded]();
      return this[$pbrTextures].get(TextureUsage.Anisotropy);
    }
  }, {
    key: "setAnisotropyStrength",
    value: function setAnisotropyStrength(strength) {
      this[$ensureMaterialIsLoaded]();
      var _iterator24 = _createForOfIteratorHelper(this[$correlatedObjects]),
        _step24;
      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var material = _step24.value;
          material.anisotropy = strength;
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }
      this[$onUpdate]();
    }
  }, {
    key: "setAnisotropyRotation",
    value: function setAnisotropyRotation(rotation) {
      this[$ensureMaterialIsLoaded]();
      var _iterator25 = _createForOfIteratorHelper(this[$correlatedObjects]),
        _step25;
      try {
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          var material = _step25.value;
          material.anisotropyRotation = rotation;
        }
      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }
      this[$onUpdate]();
    }
  }]);
  return Material;
}(ThreeDOMElement, (_a = $variantSet, _b = $pbrTextures, $backingThreeMaterial));